const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
const BASE = (backendUrl.endsWith("/") ? backendUrl.slice(0, -1) : backendUrl) + "/api";
export const SESSION_EXPIRED = "earnos:session-expired";
export const TOKEN_KEY = "earnos_token";

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function persistToken(token) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {}
}

export function clearToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {}
}

export async function apiFetch(path, opts = {}) {
  const { method = "GET", body, auth = true, responseType = "json" } = opts;
  const headers = { "Content-Type": "application/json" };
  const requestToken = auth ? getToken() : null;
  if (auth) {
    const token = requestToken;
    if (token) headers["Authorization"] = `Bearer ${token}`;
  }
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.ok && responseType === "blob") return res.blob();
  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }
  if (!res.ok) {
    if (auth && res.status === 401 && requestToken && requestToken === getToken()) {
      clearToken();
      window.dispatchEvent(new Event(SESSION_EXPIRED));
    }
    const detail = (data && (data.detail || data.message)) || `Request failed (${res.status})`;
    const message = typeof detail === "string" ? detail : Array.isArray(detail) ? detail.slice(0, 3).map(item => `${(item.loc || []).filter(x => x !== "body").join(".") || "Input"}: ${item.msg || "Invalid value"}`).join("; ") : "Request failed";
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }
  return data;
}
